import { ArrowRight, Check } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader } from "./ui/card";

const plans = [
  {
    id: "basico",
    name: "Básico",
    price: "$299",
    period: "MXN/mes",
    description: "Para agentes que están comenzando",
    properties: "1 landing page",
    features: [
      "1 Plantilla (Clásica)",
      "Colores personalizados",
      "Formulario de contacto y/o WhatsApp",
      "Galería de hasta 10 fotos",
      "Video de YouTube / Vimeo",
      "Tracking pixels (Meta, GA, Ads)",
      "Dashboard de leads + notificaciones",
      "Exportación CSV de leads",
      "Soporte por email"
    ],
    highlighted: false,
    cta: "Comenzar"
  },
  {
    id: "pro",
    name: "Pro",
    price: "$599",
    period: "MXN/mes",
    description: "Para agentes activos con varias propiedades",
    properties: "5 landing pages",
    features: [
      "Todo lo del plan Básico +",
      "3 Plantillas de landing",
      "Redactor con IA (descripciones, títulos y mensajes)",
      "Integración CRM (webhook de leads)",
      "Estadísticas de visitas",
      "Soporte prioritario"
    ],
    highlighted: true,
    cta: "Comenzar"
  },
  {
    id: "premium",
    name: "Premium",
    price: "$1,099",
    period: "MXN/mes",
    description: "Para equipos y brokers",
    properties: "20 landing pages",
    features: [
      "Todo lo del plan Pro +",
      "Dominio personalizado",
      "Múltiples usuarios",
      "Contacto directo con soporte"
    ],
    highlighted: false,
    cta: "Comenzar"
  }
];

export const Contact = () => {
  const handlePlanClick = (planId) => {
    window.location.href = `/register?plan=${planId}`;
  };

  return (
    <section id="precios" className="py-24 bg-gradient-to-br from-gray-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-purple-100 text-brand-purple px-4 py-1 rounded-full text-sm font-medium mb-4">
            Precios
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Planes que <span className="text-brand-purple">crecen contigo</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Elige tu plan. Cancela cuando quieras.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <Card
              key={index}
              className={`relative ${
                plan.highlighted 
                  ? 'border-2 border-brand-purple shadow-2xl scale-105' 
                  : 'border border-gray-200 hover:border-purple-200'
              } transition-all duration-300`}
            >
              {plan.highlighted && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="bg-brand-purple text-white text-sm font-medium px-4 py-1 rounded-full">
                    Más Popular
                  </span>
                </div>
              )}
              
              <CardHeader className="text-center pt-8">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <p className="text-gray-500 text-sm mb-4">{plan.description}</p>
                <div className="flex items-baseline justify-center">
                  <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-gray-500 ml-1">{plan.period}</span>
                </div>
                {plan.properties && (
                  <div className="mt-4">
                    <span className="inline-block bg-purple-50 text-brand-purple font-semibold px-4 py-1.5 rounded-full text-sm border border-purple-200">
                      {plan.properties}
                    </span>
                  </div>
                )}
              </CardHeader>
              
              <CardContent className="pt-6">
                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-600 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Button
                  onClick={() => handlePlanClick(plan.id)}
                  className={`w-full ${
                    plan.highlighted
                      ? 'bg-brand-purple hover:bg-brand-pink text-white'
                      : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
                  }`}
                >
                  {plan.cta}
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Enterprise CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            ¿Tienes una agencia grande o necesitas un plan personalizado?
          </p>
          <Button 
            variant="outline" 
            className="border-brand-purple text-brand-purple hover:bg-purple-50"
            onClick={() => handlePlanClick('agencia')}
          >
            Plan Agencia - $3,999/mes (propiedades ilimitadas)
          </Button>
        </div>
      </div>
    </section>
  );
};
